import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { CharacterCounterMethod } from '@opallabs/text-editor'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { sharedStyles, sharedColors } from '../../sharedStyles/styles'
import { Displays, styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content?: string
  index?: number
  isAccountPremium?: boolean
  isMobile: boolean
  isThreaded?: boolean
  modulesLength?: number
  onContentChange: (val: string) => void
  postType: string
  readOnly: boolean
}

export const TwitterStreamHeader: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content = '',
  index = -1,
  isAccountPremium,
  isMobile,
  isThreaded = false,
  modulesLength = -1,
  onContentChange,
  postType,
  readOnly,
}) => {
  const characterLimit = isAccountPremium ? 25_000 : 280
  const [isExpanded, setIsExpanded] = useState(false)
  const showMoreThreshold = 280
  const isTruncated =
    isAccountPremium && !isExpanded && content.length > showMoreThreshold
  const caretIcon = isMobile ? 'twitter-mobile-caret' : 'twitter-desktop-caret'

  return (
    <div
      css={styles.getAccountHeaderWrapper(
        isMobile ? Displays.mobile : Displays.desktop,
        postType
      )}
    >
      <div css={styles.getAccountHeader(isMobile)}>
        <ContentAvatar assetReference={accountImage} size={52} />
        <div css={sharedStyles.flexColumn}>
          <div css={styles.getAccountNames(isMobile)}>
            <AccountName
              name={accountName}
              size={15}
              color={sharedColors.darkGreyText}
              style={styles.accountName}
            />
            {accountUsername && (
              <AccountName
                accountHandle="@"
                name={accountUsername}
                size={15}
                style={sharedStyles.getAccountUsername(true)}
              />
            )}
            <span css={sharedStyles.getScheduledTimeText(true)}>&#183;</span>
            <span css={sharedStyles.getScheduledTimeText(true)}>1m</span>
          </div>
          <div css={styles.getContentWrapper(isMobile)}>
            <ContentTextInput
              key={characterLimit}
              characterLimit={characterLimit}
              characterCounterOptions={{
                counterMethod: CharacterCounterMethod.TwitterX,
              }}
              placeholder="What's happening?"
              readOnly={readOnly}
              value={content}
              highlightSocialTags={true}
              truncate={isTruncated}
              truncationLimit={showMoreThreshold}
              onChange={(val: string) => onContentChange(val)}
              style={styles.content}
            />
            {isAccountPremium && content.length > showMoreThreshold && (
              <button
                css={{
                  background: 'none',
                  border: 'none',
                  color: '#1d9bf0',
                  cursor: 'pointer',
                  fontSize: 15,
                  padding: 0,
                  paddingLeft: 4,
                }}
                onClick={() => setIsExpanded((prev) => !prev)}
              >
                {isExpanded ? 'Show less' : 'Show more'}
              </button>
            )}
          </div>
        </div>
      </div>
      {isThreaded && index > 0 && (
        <div
          className={kuiperClassNames('threaded-tweet')}
          css={styles.getTopThreadStyles(isMobile)}
        />
      )}
      {isThreaded && index !== (modulesLength || 0) - 1 && (
        <div
          className={kuiperClassNames('threaded-tweet')}
          css={styles.threadStyles}
        />
      )}
      <div css={sharedStyles.getTwitterCaretWrapper(true)}>
        {renderIcon(caretIcon, { height: 6, width: 11, ariaMode: 'hidden' })}
      </div>
    </div>
  )
}
